var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('va-navibar'),_c('va-slider',{attrs:{"slideMenuItems":_vm.slideMenuItems}}),_c('va-content-wrap'),_c('Modal'),_c('login-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }